<template>
  <div class="newbie">
    <van-nav-bar title="新手礼包" left-arrow @click-left="$router.push({ path: '/home' })" />

    <div class="tian-grid mt-10" v-if="false">
      <div class="tian-grid-item">
        <div class="tian-gi-main">
          <span class="level level-1"></span>
          <div class="tian-desc-award">
            <img src="../../assets/img/u39.png" alt />
            <span>100莲币</span>
          </div>
          <div class="tian-desc-txt">注册可领取</div>
          <div class="tian-gi-desc">
            <van-button type="danger" @click="onClaim">{{
              newbie.giftBag
            }}</van-button>
          </div>
        </div>
      </div>
      <div class="tian-grid-item">
        <div class="tian-gi-main">
          <span class="level level-2"></span>
          <div class="tian-desc-award">
            <img src="../../assets/img/u39.png" alt />
            <span>300莲币</span>
          </div>
          <div class="tian-desc-txt">完成风险测评可领取</div>
          <div class="tian-gi-desc">
            <van-button plain type="danger" @click="onRisk">{{
              newbie.riskMsg
            }}</van-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新手投资专区 -->
    <div class="mt-10" v-show="greenhand_one.length || greenhand_list.length">
      <div class="van-cell-group__title">
        <span style="font-size: 16px; color: #333">新手投资专区</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;新手专享</span>
        <span>&nbsp;限1次</span>
      </div>
      <div class="newbie-newcom-enjoy" v-show="greenhand_one.length">
        <div class="newbie-ne-main" v-for="(item, index) in greenhand_one" :key="index" @click="buying(item.id, 'newcom')">
          <div class="newbie-ne-top">
            <span v-show="item.label">{{ item.label }}</span>
            <span>{{ item.name }}</span>
          </div>
          <div class="newbie-ne-deadline">期限 {{ item.investDuration }}天</div>
          <div class="newbie-ne-earnings">
            <span>{{ item.expectedRate }}%</span>
            <i v-show="item.greenhandRate">+</i>
            <span v-show="item.greenhandRate">{{ item.greenhandRate }}%</span>
          </div>
          <div class="newbie-ne-earnings-desc">预期年化收益率</div>
          <van-button v-if="item.isFull || item.serverTime >= item.endTime" class="newbie-ne-btn" type="danger" @click="buying(item.id, 'newcom')" round>已售罄</van-button>
          <van-button v-else class="newbie-ne-btn" type="danger" @click="buying(item.id, 'newcom')" round>买入</van-button>
        </div>
      </div>

      <!-- 新手资产列表 >>>  -->
      <div class="home-greenhand_list" v-show="greenhand_list.length">
        <div v-for="(item, eq) in greenhand_list" :key="eq" class="tian-deail">
          <div class="tian-item" @click.stop.prevent="onToDetail(item.id)">
            <div class="tian-item-main">
              <div class="tian-item-title">
                <span>{{ item.name }}</span>
                <span v-if="item.label">{{ item.label }}</span>
              </div>
              <div class="tian-item-content">
                <div class="tian-ic-1">
                  <div class="tian-ic1-title">
                    <span>{{ item.expectedRate }}</span>
                    <i>%</i>
                  </div>
                  <div class="tian-ic1-desc">
                    <span>预期年化收益率</span>
                  </div>
                </div>
                <div class="tian-ic-2">
                  <div class="tian-ic2-title">
                    <span>{{ item.investDuration }}天</span>
                  </div>
                  <div class="tian-ic2-desc">
                    <span>金融机构保障</span>
                  </div>
                </div>
                <div class="tian-ic-3">
                  <div v-if="item.isFull || item.serverTime >= item.endTime" class="ta-c color-red" style="font-size: 14px">
                    已售罄
                  </div>
                  <div v-else lass="tian-ic3-title">
                    <div class="progress">
                      <div class="progress-pivot" :style="{ width: item.sold + '%' }"></div>
                      <div class="text" :style="{
                          backgroundImage:
                            'linear-gradient(to right,#fff 0%, #fff ' +
                            item.sold +
                            '% ,#DF4744 ' +
                            item.sold +
                            '%,#DF4744 100%)',
                        }">
                        已售 {{ item.sold }}%
                      </div>
                    </div>
                  </div>
                  <div class="tian-ic3-desc">
                    <!-- {{ item.miniAmount / 100 }} 元起投 -->
                    <span>低风险 </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部的占位符 -->
      <div class="newbie-footer-placeholder"></div>
    </div>
  </div>
</template>

<script>
import * as HomeApi from '@/api/home'
import storage from '@/utils/storage'
import { mapGetters, mapActions, mapMutations } from 'vuex'

import {
  Tag,
  Row,
  Col,
  NavBar,
  Toast,
  Cell,
  CellGroup,
  Button,
  Image,
  Dialog,
} from 'vant'

export default {
  components: {
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
  },

  data() {
    return {
      newbie: {
        riskMsg: '马上评测',
        giftBag: '马上领取', // 注册领 100 莲币
      },

      greenhand_one: [],
      greenhand_list: [], //  资产列表
    }
  },

  beforeMount() {
    this.getGreenhand()
    //forceAssess 是否强制评测
    //assessNum 已评测次数
    // if (this.userInfo && this.userInfo.assessNum > 0) {
    if (this.userInfo && this.userInfo.userLevel > 0) {
      this.newbie.riskMsg = '已评测'
    }
    storage.set('hot_view', true)
  },
  computed: {
    ...mapGetters(['userInfo', 'payType', 'channel']),
  },
  methods: {
    ...mapActions(['getUserInfo']),
    getGreenhand() {
      // 新手产品
      let sendForm = {
        pageNo: 1,
        pageSize: 1000,
      }
      HomeApi.greenhand(sendForm)
        .then((data) => {
          this._dismissLoading()
          if (!data || !data.list || !data.list.length) return

          this.greenhand_one = [data.list[0]]
          this.greenhand_list = data.list.filter((item, index) => {
            if (index !== 0) return item
          })
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },

    // 点击 前往详情
    onToDetail(productId) {
      this.$router.push({ path: '/detail', query: { productId } })
    },

    onClickLeft() {
      this.goableBack()
    },

    onClaim() {
      let token = storage.get('app-token')
      if (!token) {
        this.$router.push('/login')
      }
    },

    onRisk() {
      let user_info = storage.getJson('user-info') // 是否已评测 
      //forceAssess 是否强制评测
      //assessNum 已评测次数
      // if (user_info && userInfo.assessNum > 0) {
      if (user_info && user_info.userLevel) {
        Dialog.confirm({
          title: '提示',
          message: '您已测评, 是否再次测评 !',
        }).then(() => {
          this.$router.push('/questions')
        })
        return
      }
      this.$router.push('/questions')
    },

    buying(productId) {
      if (!this._confirmLogin()) {
        return
      }

      this.$router.push({
        path: 'detail',
        query: {
          productId,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.newbie {
  position: relative;
  background-color: #f1f5f8;
  min-height: 100vh;
  margin-bottom: -100px; // tabbar - height

  .newbie-newcom-enjoy {
    background-color: #fff;
    background-size: cover;
    background-repeat: no-repeat;

    padding-top: 18px;
    padding-bottom: 18px;
    text-align: center;
    position: relative;

    .newbie-ne-icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 70px;
    }
    .newbie-ne-main {
      position: relative;
      font-family: PingFangSC-Regular;
      font-size: 0;
    }
    .newbie-ne-top {
      span:nth-of-type(1) {
        height: 15px;
        border: solid 1px #d49e1f;
        padding-left: 6px;
        padding-right: 6px;
        margin-left: -30px;
        font-size: 10px;
        color: #d3b264;
        position: relative;
        top: -1px;
      }
      span:nth-of-type(2) {
        font-size: 14px;
        color: #333;
        margin-left: 12px;
      }
    }
    .newbie-ne-deadline {
      font-size: 12px;
      color: #999999;
      margin-top: 6px;
    }
    .newbie-ne-earnings {
      margin-top: 10px;
      font-family: PingFangSC-Medium;
      font-weight: bold;
      * {
        display: inline-block;
      }
      span {
        font-size: 36px;
        color: #df4744;
        font-family: PingFangSC-Medium;
      }
      i {
        font-size: 16px;
        color: #df4744;
        position: relative;
        top: -10px;
        font-style: normal;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .newbie-ne-earnings-desc {
      font-size: 12px;
      color: #999999;
    }
    .newbie-ne-btn {
      width: 210px;
      height: 38px;
      line-height: 38px;
      background-color: #df4744;
      border-radius: 19px;
      margin-top: 16px;
      font-size: 18px;
      letter-spacing: 1px;
      color: #ffffff;
    }
  }

  .tian-grid {
    margin-bottom: -8px;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
  }
  .tian-grid-item {
    display: inline-block;
    width: 50%;
    position: relative;
    padding-right: 4px;
    margin-bottom: 8px;
    vertical-align: middle;
    box-sizing: border-box;
    overflow: hidden;
    height: 210px;
    .tian-gi-main {
      width: 100%;
      position: relative;
      height: 100%;
      background-color: white;
      overflow: hidden;
    }
    img {
      width: 100%;
    }
    .level {
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      height: 10px;
      line-height: 10px;
      font-size: 14px;
    }
    .level-1 {
      background-color: #c1a76a;
    }
    .level-2 {
      background-color: #9fadae;
    }
    .level-3 {
      background-color: #d9d8d4;
    }
    .level-4 {
      background-color: #373131;
      color: #fff;
    }
    .tian-desc-award {
      text-align: center;
      margin-top: 40px;

      img,
      span {
        vertical-align: middle;
        display: inline-block;
      }
      img {
        width: 20px;
      }
      span {
        margin-left: 10px;
        font-size: 20px;
        color: #c1a76a;
      }
    }
    .tian-desc-txt {
      text-align: center;
      margin-top: 45px;
    }
    .tian-gi-desc {
      text-align: center;
      position: absolute;
      left: 0;
      bottom: 30px;
      width: 100%;
    }
  }
  .tian-grid-item:nth-of-type(2n) {
    padding-right: 0px;
    padding-left: 4px;
  }

  // 新手礼包内的资产列表 >>>
  .home-greenhand_list {
    .tian-deail {
      position: relative;

      &::after {
        position: absolute;
        content: " ";
        bottom: 0;
        left: 20px;
        right: 0;
        border-width: 1px;
        border-bottom: 1px solid transparent;
        z-index: 10;
        border-image: linear-gradient(to right, #9fadae, #f1f5f8 50%) 30 30;
      }
    }
    .tian-deail:last-child {
      &::after {
        display: none;
      }
    }
    .tian-item {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 10px;
      position: relative;
      background-color: #ffffff;
    }
    .tian-item-main {
      padding-top: 20px;
      padding-bottom: 20px;
      position: relative;
    }
    .tian-item-title {
      span:nth-of-type(1) {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        letter-spacing: 0px;
        color: #333333;
      }
      span:nth-of-type(2) {
        height: 15px;
        border: solid 1px #d49e1f;
        padding-left: 6px;
        padding-right: 6px;
        margin-left: 12px;
        font-size: 10px;
        color: #d3b264;
        position: relative;
        top: -2px;
      }
    }
    .tian-item-content {
      margin-top: 22px;
      font-size: 0;

      * {
        line-height: 1;
      }

      .tian-ic-1 {
        display: inline-block;

        .tian-ic1-title {
          text-align: center;
          span {
            font-family: PingFangSC-Semibold;
            font-size: 24px;
            color: #df4744;
            font-weight: bold;
          }
          i {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #df4744;
          }
        }

        .tian-ic1-desc {
          span {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #afbac5;
            margin-top: 22px;
            display: inline-block;
          }
        }
      }

      .tian-ic-2 {
        display: inline-block;
        margin-left: 26px;

        .tian-ic2-title {
          text-align: center;
          span {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            letter-spacing: 0px;
            color: #333333;
          }
        }

        .tian-ic2-desc {
          span {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #afbac5;
            margin-top: 22px;
            display: inline-block;
          }
        }
      }

      .tian-ic-3 {
        display: inline-block;
        margin-left: 26px;

        .tian-ic3-title {
          .progress {
            height: 16px;
            line-height: 16px;
            position: relative;
            border: 1px solid @red;
            .progress-pivot {
              height: 100%;
              background: linear-gradient(to left, #f68d85, @red);
            }
            .text {
              position: absolute;
              height: 100%;
              line-height: 1.3;
              width: 100%;
              text-align: center;
              top: 0;
              left: 0;
              font-size: 12px;
              //background-image: linear-gradient(to right,#fff 0%, #fff 72% ,#DF4744 72%,#DF4744 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
        }

        .tian-ic3-desc {
          span {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #afbac5;
            margin-top: 22px;
            display: inline-block;
          }
        }
      }
    }
  }

  // 页面底部的占位区
  .newbie-footer-placeholder {
    height: 100px;
    background-color: #f1f5f8;
  }
}
</style>
